import axios from 'axios';
import { getApiEndpoint } from './utilities';

export default {

    lookupAddress(payload, cb) {
        axios.post(getApiEndpoint() + "api/address/perform-lookup", payload)
            .then(response => {
                cb(response.data);
            });
    },

    getAddressById(payload, cb) {
        axios.get(getApiEndpoint() + "api/address/get-address?id=" + payload.id)
            .then(response => {
                cb(response.data);
            });
    }
}

